import React from 'react';
import Loader from 'src/components/loader';
import loadable from '@loadable/component';
import expertLandingPageQuery from './query.graphql';

const ExpertLandingPage = loadable(
  () => import(/* webpackChunkName: "expert" */ './landing-page'),
  {
    fallback: <Loader />,
  }
);

ExpertLandingPage.graphQL = expertLandingPageQuery;

ExpertLandingPage.variables = () => {
  // Configure popular categories here as a temp solution
  return {
    limit: 4,
    popCategories: ['horlurar', 'barnvagnar', 'mobiltelefoner', 'schampo'],
  };
};

export default ExpertLandingPage;
